export default __webpack_public_path__ + "static/media/closeIconWhite.d2e1b497.svg";